"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Block = void 0;
var Hash_1 = require("./Hash");
var Transaction_1 = require("../Transaction/Transaction");
var Serialization_1 = require("../../Handlers/Serialization");
var lodash_1 = require("lodash");
var Header_1 = require("./Header");
var js_sha3_1 = require("js-sha3");
var Block = /** @class */ (function () {
    function Block(block) {
        this.block = block;
    }
    Block.read = function (buffer, offset) {
        var _a = Header_1.Header.read(buffer, offset), header = _a.header, offset_header = _a.offset;
        var _b = Serialization_1.readVarInt(buffer, offset_header), commitmentsLength = _b.value, offset_commitmentsLength = _b.offset;
        offset = offset_commitmentsLength;
        var commitments = [];
        for (var i = 0; i < commitmentsLength; i++) {
            var _c = Hash_1.Hash.read(buffer, offset), hash = _c.hash, offset_hash = _c.offset;
            commitments.push(hash);
            offset = offset_hash;
        }
        var txMerkleRoot = commitments[0];
        var witnessMerkleRoot = commitments[1];
        var activeContractSetMerkleRoot = commitments[2];
        var commitment = commitments.slice(3);
        var _d = Serialization_1.readVarInt(buffer, offset), transactionLength = _d.value, offset_transaction = _d.offset;
        offset = offset_transaction;
        var transactions = [];
        for (var i = 0; i < transactionLength; i++) {
            var _e = Transaction_1.Transaction.read(buffer, offset, true), tx = _e.tx, offset_tx = _e.offset;
            transactions.push(tx);
            offset = offset_tx;
        }
        var block = {
            header: header,
            txMerkleRoot: txMerkleRoot,
            witnessMerkleRoot: witnessMerkleRoot,
            activeContractSetMerkleRoot: activeContractSetMerkleRoot,
            commitments: commitment,
            transactions: transactions,
        };
        return { block: new Block(block), offset: offset };
    };
    Block.fromHex = function (hex) {
        var buffer = Buffer.from(hex, 'hex');
        var block = Block.read(buffer, 0).block;
        return block;
    };
    Block.prototype.getSize = function () {
        var commitmentSize = Serialization_1.getSizeOfVarInt(this.block.commitments.length + 3) +
            this.block.txMerkleRoot.getSize() +
            this.block.witnessMerkleRoot.getSize() +
            this.block.activeContractSetMerkleRoot.getSize() +
            lodash_1.sumBy(this.block.commitments, function (hash) { return hash.getSize(); });
        var transactionsSize = Serialization_1.getSizeOfVarInt(this.block.transactions.length) +
            lodash_1.sumBy(this.block.transactions, function (tx) { return tx.getSize(true); });
        return this.block.header.getSize() + commitmentSize + transactionsSize;
    };
    Block.prototype.write = function (buffer, offset) {
        offset = this.block.header.write(buffer, offset);
        offset = Serialization_1.writeVarInt(this.block.commitments.length + 3, buffer, offset);
        offset = this.block.txMerkleRoot.write(buffer, offset);
        offset = this.block.witnessMerkleRoot.write(buffer, offset);
        offset = this.block.activeContractSetMerkleRoot.write(buffer, offset);
        this.block.commitments.forEach(function (hash) { return offset = hash.write(buffer, offset); });
        offset = Serialization_1.writeVarInt(this.block.transactions.length, buffer, offset);
        this.block.transactions.forEach(function (tx) { return offset = tx.write(buffer, offset, true); });
        return offset;
    };
    Block.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    Block.prototype.toHex = function () {
        return this.serialize().toString('hex');
    };
    Block.prototype.toJson = function () {
        return {
            header: this.block.header,
            txMerkleRoot: this.block.txMerkleRoot,
            witnessMerkleRoot: this.block.witnessMerkleRoot,
            activeContractSetMerkleRoot: this.block.activeContractSetMerkleRoot,
            commitments: this.block.commitments,
            transactions: this.block.transactions,
        };
    };
    Block.prototype.toApiJson = function () {
        return {
            hash: this.hash().toString(),
            header: this.block.header.toApiJson(),
            transactions: this.block.transactions.map(function (tx) { return tx.toApiJson(); }),
        };
    };
    Block.prototype.hash = function () {
        var buffer = this.block.header.serialize();
        return new Hash_1.Hash(js_sha3_1.sha3_256(buffer));
    };
    return Block;
}());
exports.Block = Block;
//# sourceMappingURL=Block.js.map